module.exports = __webpack_public_path__ + "img/offshore-laboratory.d5113166.jpg";